<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import CustomButton from "@/components/Button/Button.vue";

const { t } = useI18n(); // Import the translation function
</script>

<template>
  <div class="container flex flex-col justify-center items-center py-20 gap-4">
    <img src="/assets/images/sorry.svg" alt="back" class="2xl:w-18vw xl:w-20vw md:w-30vw sm:w-45vw">
    <div class="font-bold responsive-title-6 text-center">{{ t('somethingWentWrong') }}</div>
    <div class="text-center">{{ t('description') }}</div>
    <CustomButton @click="$router.push('/')"
                  size="large"
                  type="black"
                  :rounded="true"
                  class="w-fit font-semibold">
      {{ t('backToTrip') }}</CustomButton>
  </div>
</template>
